
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { React_useElmish_Z6C327F2E } from "../../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { update as update_1, init as init_1 } from "./State.js";
import { reactApi, reactElement } from "../../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { createObj } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { join } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { empty, singleton, append, delay, toList } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { CustomerNotificationSettings } from "../../../Widgets/NotificationSettings.js";
import { Msg } from "./Types.js";
import { FormState__getValidation } from "../../../Shared/Shared.js";
import { ErrorAlert } from "../../../Components/Alert.js";
import { Button } from "../../../Components/Button.js";
import { ofArray } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { Skeleton } from "../../../Components/Skeleton.js";

export function NotificationSettingsSection() {
    let elems_1;
    const t = useTranslation()[0];
    const patternInput_1 = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(init_1, update_1, (_arg, _arg_1) => {
    }), undefined, []);
    const state_1 = patternInput_1[0];
    const dispatch = patternInput_1[1];
    const componentState = state_1.FormState.IsLoading ? "disabled" : "enabled";
    return reactElement("div", createObj(ofArray([["data-test-id", "customer-notification-settings"], ["className", join(" ", ["flex", "flex-col", "gap-4"])], (elems_1 = toList(delay(() => {
        const matchValue = state_1.Settings;
        return (matchValue.tag === 1) ? append(singleton(createElement(CustomerNotificationSettings, {
            ComponentState: componentState,
            OnChange: (arg) => {
                dispatch(new Msg(1, [arg]));
            },
            Settings: matchValue.fields[0],
        })), delay(() => {
            let matchValue_1;
            return append((matchValue_1 = FormState__getValidation(state_1.FormState, t, "global"), (matchValue_1 == null) ? (empty()) : singleton(createElement(ErrorAlert, {
                Label: matchValue_1,
            }))), delay(() => {
                let elems;
                return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-end"])], (elems = [createElement(Button, {
                    ComponentState: componentState,
                    Label: t("general.save"),
                    OnClick: () => {
                        dispatch(new Msg(2, []));
                    },
                    TestId: "update-customer-notification-settings",
                    Variant: "primary",
                })], ["children", reactApi.Children.toArray(Array.from(elems))])]))));
            }));
        })) : singleton(createElement(Skeleton, {
            Variant: "normal",
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

